import type { KeyboardEvent, ReactNode } from "react";
import { PRACTICE_AREA } from "../../domain/user.domain";

interface NudgeLogoProps {
  practiceArea?: number;
  onClick?: () => void;
  showDomain?: boolean;
  compact?: boolean;
  tierAdornment?: ReactNode;
}

// Behavioral Health icon - brain/mind icon
const BehavioralHealthIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Behavioral Health"
  >
    <title>Behavioral Health</title>
    <path
      d="M6.37492 3.3748C6.37492 3.30063 6.35293 3.22813 6.31172 3.16646C6.27052 3.10479 6.21195 3.05673 6.14343 3.02834C6.07491 2.99996 5.99951 2.99254 5.92676 3.00701C5.85402 3.02147 5.7872 3.05719 5.73476 3.10963C5.68231 3.16208 5.6466 3.2289 5.63213 3.30164C5.61766 3.37438 5.62508 3.44978 5.65347 3.51831C5.68185 3.58683 5.72991 3.6454 5.79158 3.6866C5.85325 3.72781 5.92575 3.7498 5.99992 3.7498C6.09938 3.7498 6.19476 3.71029 6.26509 3.63996C6.33541 3.56964 6.37492 3.47426 6.37492 3.3748ZM5.24992 6.3748C5.24992 6.44897 5.22793 6.52147 5.18672 6.58314C5.14552 6.64481 5.08695 6.69287 5.01843 6.72125C4.94991 6.74964 4.87451 6.75706 4.80176 6.74259C4.72902 6.72812 4.6622 6.69241 4.60976 6.63996C4.55731 6.58752 4.5216 6.5207 4.50713 6.44796C4.49266 6.37522 4.50008 6.29982 4.52847 6.23129C4.55685 6.16277 4.60491 6.1042 4.66658 6.063C4.72825 6.02179 4.80075 5.9998 4.87492 5.9998C4.97438 5.9998 5.06976 6.03931 5.14009 6.10963C5.21041 6.17996 5.24992 6.27534 5.24992 6.3748ZM2.97648 8.03746C2.50197 7.63896 2.12296 7.13903 1.8674 6.57454C1.61185 6.01005 1.48627 5.39539 1.49992 4.77589C1.49992 4.74152 1.50133 4.7073 1.50414 4.67324C1.50712 4.62557 1.52819 4.58083 1.56304 4.54817C1.59788 4.5155 1.64388 4.49736 1.69164 4.49746H2.82414L3.90836 5.79824C3.77293 6.02648 3.72256 6.29524 3.76613 6.55703C3.80971 6.81882 3.94444 7.05678 4.14649 7.22884C4.34855 7.4009 4.60494 7.49599 4.87033 7.49729C5.13571 7.4986 5.39302 7.40604 5.59676 7.23598C5.80051 7.06592 5.93757 6.8293 5.98372 6.56795C6.02988 6.3066 5.98215 6.03735 5.84898 5.80779C5.71581 5.57823 5.50577 5.40314 5.25598 5.31347C5.0062 5.2238 4.73275 5.22532 4.48398 5.31777L3.2882 3.88246C3.25277 3.84061 3.20859 3.80705 3.15879 3.78413C3.10898 3.76121 3.05475 3.74949 2.99992 3.7498H1.91523C1.88515 3.74984 1.8555 3.74263 1.82878 3.72879C1.80207 3.71496 1.77907 3.6949 1.76175 3.6703C1.74442 3.64571 1.73326 3.61731 1.72921 3.5875C1.72517 3.55769 1.72836 3.52734 1.73851 3.49902C2.28414 1.96855 3.70961 0.84355 5.40273 0.75355H5.43039C5.4556 0.752604 5.48074 0.756754 5.5043 0.765753C5.52787 0.774751 5.54938 0.788412 5.56754 0.805918C5.5857 0.823424 5.60015 0.844415 5.61001 0.867635C5.61987 0.890854 5.62494 0.915824 5.62492 0.94105V2.31214C5.37472 2.4006 5.16384 2.57467 5.02956 2.80357C4.89528 3.03248 4.84625 3.30148 4.89112 3.56304C4.936 3.8246 5.0719 4.06188 5.2748 4.23293C5.4777 4.40399 5.73454 4.4978 5.99992 4.4978C6.2653 4.4978 6.52214 4.40399 6.72504 4.23293C6.92794 4.06188 7.06384 3.8246 7.10872 3.56304C7.1536 3.30148 7.10456 3.03248 6.97028 2.80357C6.836 2.57467 6.62513 2.4006 6.37492 2.31214V1.04652C6.37485 1.01831 6.38114 0.990449 6.39333 0.96501C6.40552 0.939572 6.4233 0.917211 6.44533 0.899595C6.46736 0.881979 6.49308 0.869561 6.52058 0.863266C6.54808 0.85697 6.57664 0.856961 6.60414 0.863237C7.48614 1.07985 8.27221 1.58098 8.84083 2.28915C9.40945 2.99732 9.72895 3.87309 9.74992 4.78105L10.8023 6.80324L10.8126 6.82433C10.8893 7.00039 10.8955 7.19915 10.83 7.37968C10.7645 7.5602 10.6323 7.70873 10.4605 7.79464L10.4488 7.80027L9.37492 8.29199V9.74511C9.37492 9.94402 9.2959 10.1348 9.15525 10.2754C9.0146 10.4161 8.82383 10.4951 8.62492 10.4951H6.74992V10.8701C6.74992 10.9696 6.71041 11.065 6.64009 11.1353C6.56976 11.2056 6.47438 11.2451 6.37492 11.2451H3.0107C2.94433 11.2457 2.87888 11.2296 2.82039 11.1982C2.75439 11.1622 2.70073 11.1072 2.66637 11.0404C2.63202 10.9735 2.61856 10.8979 2.62773 10.8232L2.97648 8.03746Z"
      fill="#EA580C"
    />
  </svg>
);

// Medicine icon - heart with pulse
const MedicineIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Medicine">
    <title>Medicine</title>
    <path
      d="M11.25 4.78174C11.25 8.06299 6.38484 10.7189 6.17766 10.8286C6.12305 10.858 6.06201 10.8734 6 10.8734C5.93799 10.8734 5.87695 10.858 5.82234 10.8286C5.66531 10.7442 2.84344 9.20252 1.47797 7.03689C1.46036 7.00853 1.45064 6.97597 1.44982 6.94259C1.449 6.90921 1.45711 6.87622 1.4733 6.84702C1.4895 6.81782 1.51321 6.79348 1.54196 6.77651C1.57072 6.75954 1.60348 6.75056 1.63687 6.75049H3.375C3.43675 6.75053 3.49756 6.73532 3.55202 6.70621C3.60648 6.67709 3.65291 6.63498 3.68719 6.58361L4.125 5.92736L5.31281 7.70861C5.35833 7.77687 5.42497 7.82832 5.50252 7.85508C5.58008 7.88183 5.66427 7.88242 5.74219 7.85674C5.82485 7.82875 5.89557 7.77355 5.94281 7.70018L6.57562 6.75049H7.5C7.55141 6.7506 7.60229 6.74014 7.64949 6.71976C7.69668 6.69938 7.73918 6.66952 7.77435 6.63202C7.80952 6.59452 7.8366 6.5502 7.85391 6.50179C7.87123 6.45339 7.87841 6.40194 7.875 6.35064C7.86661 6.25426 7.82209 6.1646 7.75037 6.09966C7.67865 6.03472 7.58503 5.9993 7.48828 6.00049H6.375C6.31325 6.00045 6.25244 6.01566 6.19798 6.04477C6.14351 6.07388 6.09709 6.11599 6.06281 6.16736L5.625 6.82361L4.43719 5.04236C4.39165 4.97401 4.32493 4.92249 4.24727 4.89573C4.16962 4.86897 4.08533 4.86845 4.00734 4.89424C3.92489 4.92239 3.85437 4.97756 3.80719 5.0508L3.17438 6.00049H1.10297C1.0629 6.0006 1.02384 5.98787 0.991533 5.96416C0.959224 5.94046 0.935359 5.90703 0.923438 5.86877C0.810336 5.51744 0.751842 5.15082 0.75 4.78174C0.750868 4.01122 1.05734 3.27251 1.60218 2.72767C2.14702 2.18283 2.88573 1.87636 3.65625 1.87549C4.62422 1.87549 5.47172 2.29174 6 2.99533C6.52828 2.29174 7.37578 1.87549 8.34375 1.87549C9.11427 1.87636 9.85298 2.18283 10.3978 2.72767C10.9427 3.27251 11.2491 4.01122 11.25 4.78174Z"
      fill="#059669"
    />
  </svg>
);

const NudgeLogo = ({
  practiceArea = PRACTICE_AREA.BEHAVIORAL_HEALTH,
  onClick,
  showDomain = true,
  compact = false,
  tierAdornment,
}: NudgeLogoProps) => {
  const isMedicine = practiceArea === PRACTICE_AREA.MEDICINE;
  const domainColor = isMedicine ? "#059669" : "#EA580C";
  const domainText = isMedicine ? "Medicine" : "Behavioral Health";

  const handleKeyDown = (e: KeyboardEvent) => {
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        alignItems: "flex-start",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {/* Nudge text + optional tier adornment */}
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: 800,
            fontSize: compact ? "18px" : "22px",
            lineHeight: "normal",
            color: "#51565F",
            letterSpacing: compact ? "-0.36px" : "-0.44px",
          }}
        >
          nudge
        </span>
        {tierAdornment}
      </div>

      {/* Domain indicator */}
      {showDomain && (
        <div
          style={{
            display: "flex",
            gap: "4px",
            alignItems: "center",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
          }}
        >
          {isMedicine ? <MedicineIcon /> : <BehavioralHealthIcon />}
          <span
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
              fontSize: compact ? "11px" : "12px",
              lineHeight: "normal",
              color: domainColor,
              textTransform: "capitalize",
              whiteSpace: "nowrap",
            }}
          >
            {domainText}
          </span>
        </div>
      )}
    </div>
  );
};

export default NudgeLogo;
